
export const HIGHLIGHT_ROW = '[TABLE] HIGHLIGHT CURRENT ROW';


export function highlightRow(data) {
    console.log('Receiving on Table Actions:' , data)
	return{
            type: HIGHLIGHT_ROW,
            payload: data
		}	
}
